/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Base64File: { input: any; output: any; }
  ContactDetailsOrder: { input: any; output: any; }
  ContactDetailsType: { input: any; output: any; }
  Country: { input: any; output: any; }
  Currency: { input: any; output: any; }
  CustomerOrder: { input: any; output: any; }
  CustomerType: { input: any; output: any; }
  Decimal: { input: any; output: any; }
  DeliverableOrder: { input: any; output: any; }
  DeliverableType: { input: any; output: any; }
  DiscountType: { input: any; output: any; }
  Email: { input: any; output: any; }
  FileOrder: { input: any; output: any; }
  FileType: { input: any; output: any; }
  NoContent: { input: any; output: any; }
  OrderLineOrder: { input: any; output: any; }
  OrderOrder: { input: any; output: any; }
  OrderStatus: { input: any; output: any; }
  OrderType: { input: any; output: any; }
  PaymentMethod: { input: any; output: any; }
  PaymentOrder: { input: any; output: any; }
  PaymentType: { input: any; output: any; }
  RelationType: { input: any; output: any; }
  Secret: { input: any; output: any; }
  SupplierOrder: { input: any; output: any; }
  Time: { input: any; output: any; }
  TrademarkOrder: { input: any; output: any; }
  URL: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UserOrder: { input: any; output: any; }
  UserRole: { input: any; output: any; }
  join__DirectiveArguments: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  join__FieldValue: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export type ContactDetails = {
  __typename?: 'ContactDetails';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['Country']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  email?: Maybe<Scalars['Email']['output']>;
  forename?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationID?: Maybe<Scalars['UUID']['output']>;
  relationType?: Maybe<Scalars['RelationType']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surnamePrefix?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['ContactDetailsType']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  website?: Maybe<Scalars['URL']['output']>;
};

export type ContactDetailsCreate = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['Country']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  relationID: Scalars['UUID']['input'];
  relationType: Scalars['RelationType']['input'];
  surname?: InputMaybe<Scalars['String']['input']>;
  surnamePrefix?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['ContactDetailsType']['input'];
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type ContactDetailsEnumerationResponse = {
  __typename?: 'ContactDetailsEnumerationResponse';
  orders?: Maybe<Array<Maybe<Scalars['ContactDetailsOrder']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['ContactDetailsType']['output']>>>;
};

export type ContactDetailsFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationTypes?: InputMaybe<Array<InputMaybe<Scalars['RelationType']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['ContactDetailsType']['input']>>>;
};

export type ContactDetailsInput = {
  contactDetailsFilter?: InputMaybe<ContactDetailsFilter>;
  order?: InputMaybe<Scalars['ContactDetailsOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ContactDetailsResponse = {
  __typename?: 'ContactDetailsResponse';
  records?: Maybe<Array<Maybe<ContactDetails>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type ContactDetailsUpdate = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['Country']['input']>;
  email?: InputMaybe<Scalars['Email']['input']>;
  forename?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surnamePrefix?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['ContactDetailsType']['input']>;
  website?: InputMaybe<Scalars['URL']['input']>;
};

export type Credentials = {
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

export type Customer = {
  __typename?: 'Customer';
  contactDetails?: Maybe<ContactDetailsResponse>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  files?: Maybe<FileResponse>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  orders?: Maybe<OrderResponse>;
  type?: Maybe<Scalars['CustomerType']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


export type CustomerContactDetailsArgs = {
  input?: InputMaybe<ContactDetailsInput>;
};


export type CustomerFilesArgs = {
  input?: InputMaybe<FileInput>;
};


export type CustomerOrdersArgs = {
  input?: InputMaybe<OrderInput>;
};

export type CustomerContactDetailsFilter = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['Country']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['ContactDetailsType']['input']>>>;
};

export type CustomerCreate = {
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  number: Scalars['Int']['input'];
  type: Scalars['CustomerType']['input'];
};

export type CustomerEnumerationFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['CustomerType']['input']>>>;
};

export type CustomerEnumerationInput = {
  customerFilter?: InputMaybe<CustomerEnumerationFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerEnumerationResponse = {
  __typename?: 'CustomerEnumerationResponse';
  orders?: Maybe<Array<Maybe<Scalars['CustomerOrder']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['CustomerType']['output']>>>;
};

export type CustomerFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  numbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['CustomerType']['input']>>>;
};

export type CustomerInput = {
  contactDetailsFilter?: InputMaybe<CustomerContactDetailsFilter>;
  customerFilter?: InputMaybe<CustomerFilter>;
  order?: InputMaybe<Scalars['CustomerOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerResponse = {
  __typename?: 'CustomerResponse';
  records?: Maybe<Array<Maybe<Customer>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type CustomerUpdate = {
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['CustomerType']['input']>;
};

export type Deliverable = {
  __typename?: 'Deliverable';
  createdAt?: Maybe<Scalars['Time']['output']>;
  currency?: Maybe<Scalars['Currency']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  ean?: Maybe<Scalars['String']['output']>;
  files?: Maybe<FileResponse>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trademark?: Maybe<Trademark>;
  trademarkID?: Maybe<Scalars['UUID']['output']>;
  type?: Maybe<Scalars['DeliverableType']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<UnitPrice>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  vatRate?: Maybe<Scalars['Decimal']['output']>;
};


export type DeliverableFilesArgs = {
  input?: InputMaybe<FileInput>;
};

export type DeliverableCreate = {
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  trademarkID: Scalars['UUID']['input'];
  type: Scalars['DeliverableType']['input'];
  unit: Scalars['String']['input'];
  /** Price per unit excluding VAT. */
  unitPrice: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type DeliverableEnumerationFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['DeliverableType']['input']>>>;
};

export type DeliverableEnumerationInput = {
  deliverableFilter?: InputMaybe<DeliverableEnumerationFilter>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DeliverableEnumerationResponse = {
  __typename?: 'DeliverableEnumerationResponse';
  orders?: Maybe<Array<Maybe<Scalars['DeliverableOrder']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['DeliverableType']['output']>>>;
};

export type DeliverableFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  trademarkIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['DeliverableType']['input']>>>;
};

export type DeliverableInput = {
  deliverableFilter?: InputMaybe<DeliverableFilter>;
  order?: InputMaybe<Scalars['DeliverableOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type DeliverableResponse = {
  __typename?: 'DeliverableResponse';
  records?: Maybe<Array<Maybe<Deliverable>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type DeliverableUpdate = {
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  ean?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['DeliverableType']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Price per unit excluding VAT. */
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  vatRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type File = {
  __typename?: 'File';
  createdAt?: Maybe<Scalars['Time']['output']>;
  data?: Maybe<Scalars['Base64File']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  relationID?: Maybe<Scalars['UUID']['output']>;
  relationType?: Maybe<Scalars['RelationType']['output']>;
  type?: Maybe<Scalars['FileType']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
};

export type FileCreate = {
  data: Scalars['Base64File']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  relationID: Scalars['UUID']['input'];
  relationType: Scalars['RelationType']['input'];
  type: Scalars['FileType']['input'];
};

export type FileFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationTypes?: InputMaybe<Array<InputMaybe<Scalars['RelationType']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['FileType']['input']>>>;
};

export type FileInput = {
  fileFilter?: InputMaybe<FileFilter>;
  order?: InputMaybe<Scalars['FileOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type FileResponse = {
  __typename?: 'FileResponse';
  records?: Maybe<Array<Maybe<File>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type FileUpdate = {
  data?: InputMaybe<Scalars['Base64File']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  extension?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['FileType']['input']>;
};

export type FinanceInput = {
  periodEnd: Scalars['Time']['input'];
  periodStart: Scalars['Time']['input'];
};

export type FinanceResponse = {
  __typename?: 'FinanceResponse';
  costGross?: Maybe<Scalars['Decimal']['output']>;
  costNet?: Maybe<Scalars['Decimal']['output']>;
  profitGross?: Maybe<Scalars['Decimal']['output']>;
  profitNet?: Maybe<Scalars['Decimal']['output']>;
  revenueGross?: Maybe<Scalars['Decimal']['output']>;
  revenueNet?: Maybe<Scalars['Decimal']['output']>;
  vat?: Maybe<Array<Maybe<Vat>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createContactDetails?: Maybe<ContactDetails>;
  createCustomer?: Maybe<Customer>;
  createDeliverable?: Maybe<Deliverable>;
  createFile?: Maybe<File>;
  createOrder?: Maybe<Order>;
  createOrderLine?: Maybe<OrderLine>;
  createPayment?: Maybe<Payment>;
  createSupplier?: Maybe<Supplier>;
  createTrademark?: Maybe<Trademark>;
  createUser?: Maybe<User>;
  deleteContactDetails?: Maybe<ContactDetails>;
  deleteCustomer?: Maybe<Customer>;
  deleteDeliverable?: Maybe<Deliverable>;
  deleteFile?: Maybe<File>;
  deleteOrder?: Maybe<Order>;
  deleteOrderLine?: Maybe<OrderLine>;
  deletePayment?: Maybe<Payment>;
  deleteSupplier?: Maybe<Supplier>;
  deleteTrademark?: Maybe<Trademark>;
  deleteUser?: Maybe<User>;
  removeContactDetails?: Maybe<ContactDetails>;
  removeCustomer?: Maybe<Customer>;
  removeDeliverable?: Maybe<Deliverable>;
  removeFile?: Maybe<File>;
  removeOrder?: Maybe<Order>;
  removeOrderLine?: Maybe<OrderLine>;
  removePayment?: Maybe<Payment>;
  removeSupplier?: Maybe<Supplier>;
  removeTrademark?: Maybe<Trademark>;
  removeUser?: Maybe<User>;
  restoreContactDetails?: Maybe<ContactDetails>;
  restoreCustomer?: Maybe<Customer>;
  restoreDeliverable?: Maybe<Deliverable>;
  restoreFile?: Maybe<File>;
  restoreOrder?: Maybe<Order>;
  restoreOrderLine?: Maybe<OrderLine>;
  restorePayment?: Maybe<Payment>;
  restoreSupplier?: Maybe<Supplier>;
  restoreTrademark?: Maybe<Trademark>;
  restoreUser?: Maybe<User>;
  updateContactDetails?: Maybe<ContactDetails>;
  updateCustomer?: Maybe<Customer>;
  updateDeliverable?: Maybe<Deliverable>;
  updateFile?: Maybe<File>;
  updateOrder?: Maybe<Order>;
  updateOrderLine?: Maybe<OrderLine>;
  updatePayment?: Maybe<Payment>;
  updateSupplier?: Maybe<Supplier>;
  updateTrademark?: Maybe<Trademark>;
  updateUser?: Maybe<User>;
};


export type MutationCreateContactDetailsArgs = {
  input: ContactDetailsCreate;
};


export type MutationCreateCustomerArgs = {
  input: CustomerCreate;
};


export type MutationCreateDeliverableArgs = {
  input: DeliverableCreate;
};


export type MutationCreateFileArgs = {
  input: FileCreate;
};


export type MutationCreateOrderArgs = {
  input: OrderCreate;
};


export type MutationCreateOrderLineArgs = {
  input: OrderLineCreate;
};


export type MutationCreatePaymentArgs = {
  input: PaymentCreate;
};


export type MutationCreateSupplierArgs = {
  input: SupplierCreate;
};


export type MutationCreateTrademarkArgs = {
  input: TrademarkCreate;
};


export type MutationCreateUserArgs = {
  input: UserCreate;
};


export type MutationDeleteContactDetailsArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteDeliverableArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteOrderLineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeletePaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteSupplierArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteTrademarkArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveContactDetailsArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveDeliverableArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveOrderLineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemovePaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveSupplierArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveTrademarkArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreContactDetailsArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreDeliverableArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreFileArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreOrderLineArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestorePaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreSupplierArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreTrademarkArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRestoreUserArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationUpdateContactDetailsArgs = {
  input: ContactDetailsUpdate;
};


export type MutationUpdateCustomerArgs = {
  input: CustomerUpdate;
};


export type MutationUpdateDeliverableArgs = {
  input: DeliverableUpdate;
};


export type MutationUpdateFileArgs = {
  input: FileUpdate;
};


export type MutationUpdateOrderArgs = {
  input: OrderUpdate;
};


export type MutationUpdateOrderLineArgs = {
  input: OrderLineUpdate;
};


export type MutationUpdatePaymentArgs = {
  input: PaymentUpdate;
};


export type MutationUpdateSupplierArgs = {
  input: SupplierUpdate;
};


export type MutationUpdateTrademarkArgs = {
  input: TrademarkUpdate;
};


export type MutationUpdateUserArgs = {
  input: UserUpdate;
};

export type Order = {
  __typename?: 'Order';
  billedAt?: Maybe<Scalars['Time']['output']>;
  contactDetails?: Maybe<ContactDetailsResponse>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  currency?: Maybe<Scalars['Currency']['output']>;
  customer?: Maybe<Customer>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  discountType?: Maybe<Scalars['DiscountType']['output']>;
  discountValue?: Maybe<Scalars['Decimal']['output']>;
  files?: Maybe<FileResponse>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  orderLines?: Maybe<OrderLineResponse>;
  paid?: Maybe<Scalars['Decimal']['output']>;
  payments?: Maybe<PaymentResponse>;
  price?: Maybe<OrderPrice>;
  received?: Maybe<Scalars['Decimal']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  relationID?: Maybe<Scalars['UUID']['output']>;
  relationType?: Maybe<Scalars['RelationType']['output']>;
  shiftedVAT?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['OrderStatus']['output']>;
  supplier?: Maybe<Supplier>;
  type?: Maybe<Scalars['OrderType']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


export type OrderContactDetailsArgs = {
  input?: InputMaybe<ContactDetailsInput>;
};


export type OrderFilesArgs = {
  input?: InputMaybe<FileInput>;
};


export type OrderOrderLinesArgs = {
  input?: InputMaybe<OrderLineInput>;
};


export type OrderPaymentsArgs = {
  input?: InputMaybe<PaymentInput>;
};

export type OrderContactDetailsFilter = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['Country']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['ContactDetailsType']['input']>>>;
};

export type OrderCreate = {
  billedAt?: InputMaybe<Scalars['Time']['input']>;
  currency: Scalars['Currency']['input'];
  discountType?: InputMaybe<Scalars['DiscountType']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  memorandum?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  relationID: Scalars['UUID']['input'];
  relationType: Scalars['RelationType']['input'];
  shiftedVAT?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['OrderStatus']['input']>;
  type: Scalars['OrderType']['input'];
};

export type OrderEnumerationResponse = {
  __typename?: 'OrderEnumerationResponse';
  orders?: Maybe<Array<Maybe<Scalars['OrderOrder']['output']>>>;
  statuses?: Maybe<Array<Maybe<Scalars['OrderStatus']['output']>>>;
  types?: Maybe<Array<Maybe<Scalars['OrderType']['output']>>>;
};

export type OrderFilter = {
  billedAfter?: InputMaybe<Scalars['Time']['input']>;
  billedBefore?: InputMaybe<Scalars['Time']['input']>;
  discountTypes?: InputMaybe<Array<InputMaybe<Scalars['DiscountType']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  numbers?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  relationIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  relationTypes?: InputMaybe<Array<InputMaybe<Scalars['RelationType']['input']>>>;
  shiftedVAT?: InputMaybe<Scalars['Boolean']['input']>;
  statuses?: InputMaybe<Array<InputMaybe<Scalars['OrderStatus']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['OrderType']['input']>>>;
};

export type OrderInput = {
  contactDetailsFilter?: InputMaybe<OrderContactDetailsFilter>;
  order?: InputMaybe<Scalars['OrderOrder']['input']>;
  orderFilter?: InputMaybe<OrderFilter>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLine = {
  __typename?: 'OrderLine';
  amount?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  deliverable?: Maybe<Deliverable>;
  deliverableID?: Maybe<Scalars['UUID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['DiscountType']['output']>;
  discountValue?: Maybe<Scalars['Decimal']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  orderID?: Maybe<Scalars['UUID']['output']>;
  price?: Maybe<OrderPrice>;
  priority?: Maybe<Scalars['Int']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  unitPrice?: Maybe<UnitPrice>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  vatRate?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderLineCreate = {
  amount: Scalars['Decimal']['input'];
  deliverableID: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['DiscountType']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  orderID: Scalars['UUID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  unit: Scalars['String']['input'];
  /** Price per unit excluding VAT. */
  unitPrice: Scalars['Decimal']['input'];
  vatRate: Scalars['Decimal']['input'];
};

export type OrderLineFilter = {
  deliverableIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  discountTypes?: InputMaybe<Array<InputMaybe<Scalars['DiscountType']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  orderIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type OrderLineInput = {
  order?: InputMaybe<Scalars['OrderLineOrder']['input']>;
  orderLineFilter?: InputMaybe<OrderLineFilter>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OrderLineResponse = {
  __typename?: 'OrderLineResponse';
  records?: Maybe<Array<Maybe<OrderLine>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type OrderLineUpdate = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  deliverableID?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType?: InputMaybe<Scalars['DiscountType']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['UUID']['input'];
  priority?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
  /** Price per unit excluding VAT. */
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  vatRate?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderPrice = {
  __typename?: 'OrderPrice';
  /** Total discount value value including VAT. */
  discount?: Maybe<Scalars['Decimal']['output']>;
  /** Total price including discount and VAT. */
  grossTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Total price including discount and excluding VAT. */
  netTotal?: Maybe<Scalars['Decimal']['output']>;
  /** Total VAT value including discount. */
  vat?: Maybe<Scalars['Decimal']['output']>;
};

export type OrderResponse = {
  __typename?: 'OrderResponse';
  records?: Maybe<Array<Maybe<Order>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type OrderUpdate = {
  billedAt?: InputMaybe<Scalars['Time']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  discountType?: InputMaybe<Scalars['DiscountType']['input']>;
  discountValue?: InputMaybe<Scalars['Decimal']['input']>;
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  shiftedVAT?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['OrderStatus']['input']>;
  type?: InputMaybe<Scalars['OrderType']['input']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Decimal']['output']>;
  bic?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  currency?: Maybe<Scalars['Currency']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['PaymentMethod']['output']>;
  orderID?: Maybe<Scalars['UUID']['output']>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['PaymentType']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type PaymentCreate = {
  amount: Scalars['Decimal']['input'];
  bic?: InputMaybe<Scalars['String']['input']>;
  currency: Scalars['Currency']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  memorandum?: InputMaybe<Scalars['String']['input']>;
  method: Scalars['PaymentMethod']['input'];
  orderID: Scalars['UUID']['input'];
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['PaymentType']['input'];
};

export type PaymentFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  methods?: InputMaybe<Array<InputMaybe<Scalars['PaymentMethod']['input']>>>;
  orderIDs?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  paidAfter?: InputMaybe<Scalars['Time']['input']>;
  paidBefore?: InputMaybe<Scalars['Time']['input']>;
  references?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['PaymentType']['input']>>>;
};

export type PaymentInput = {
  order?: InputMaybe<Scalars['PaymentOrder']['input']>;
  paymentFilter?: InputMaybe<PaymentFilter>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentRedirectInput = {
  method: Scalars['PaymentMethod']['input'];
  orderID: Scalars['UUID']['input'];
  pushFailure?: InputMaybe<Scalars['URL']['input']>;
  pushSuccess?: InputMaybe<Scalars['URL']['input']>;
  returnURL?: InputMaybe<Scalars['URL']['input']>;
  returnURLCancel?: InputMaybe<Scalars['URL']['input']>;
  returnURLError?: InputMaybe<Scalars['URL']['input']>;
  returnURLReject?: InputMaybe<Scalars['URL']['input']>;
};

export type PaymentResponse = {
  __typename?: 'PaymentResponse';
  records?: Maybe<Array<Maybe<Payment>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type PaymentUpdate = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  bic?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['Currency']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  method?: InputMaybe<Scalars['PaymentMethod']['input']>;
  paidAt?: InputMaybe<Scalars['Time']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['PaymentType']['input']>;
};

export type Plot = {
  items: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};

export type Query = {
  __typename?: 'Query';
  cleanSessions?: Maybe<Scalars['NoContent']['output']>;
  contactDetails?: Maybe<ContactDetailsResponse>;
  contactDetailsEnumerations?: Maybe<ContactDetailsEnumerationResponse>;
  customer?: Maybe<Customer>;
  customerEnumerations?: Maybe<CustomerEnumerationResponse>;
  customers?: Maybe<CustomerResponse>;
  deliverable?: Maybe<Deliverable>;
  deliverableEnumerations?: Maybe<DeliverableEnumerationResponse>;
  deliverables?: Maybe<DeliverableResponse>;
  endAllSessions?: Maybe<Scalars['NoContent']['output']>;
  endSession?: Maybe<Scalars['NoContent']['output']>;
  endSessions?: Maybe<Scalars['NoContent']['output']>;
  endUserSessions?: Maybe<Scalars['NoContent']['output']>;
  files?: Maybe<FileResponse>;
  finances?: Maybe<FinanceResponse>;
  newCustomerNumber?: Maybe<Scalars['Int']['output']>;
  newOrderNumber?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
  orderEnumerations?: Maybe<OrderEnumerationResponse>;
  orderLines?: Maybe<OrderLineResponse>;
  orders?: Maybe<OrderResponse>;
  payment?: Maybe<Payment>;
  paymentRedirect?: Maybe<Scalars['URL']['output']>;
  payments?: Maybe<PaymentResponse>;
  removedCustomer?: Maybe<Customer>;
  removedCustomers?: Maybe<CustomerResponse>;
  removedDeliverable?: Maybe<Deliverable>;
  removedDeliverables?: Maybe<DeliverableResponse>;
  removedOrder?: Maybe<Order>;
  removedOrders?: Maybe<OrderResponse>;
  removedSupplier?: Maybe<Supplier>;
  removedSuppliers?: Maybe<SupplierResponse>;
  removedTrademark?: Maybe<Trademark>;
  removedTrademarks?: Maybe<TrademarkResponse>;
  sessionRoles?: Maybe<Array<Maybe<Scalars['UserRole']['output']>>>;
  startSession?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  suppliers?: Maybe<SupplierResponse>;
  trademark?: Maybe<Trademark>;
  trademarks?: Maybe<TrademarkResponse>;
  users?: Maybe<UserResponse>;
};


export type QueryContactDetailsArgs = {
  input?: InputMaybe<ContactDetailsInput>;
};


export type QueryCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryCustomerEnumerationsArgs = {
  input?: InputMaybe<CustomerEnumerationInput>;
};


export type QueryCustomersArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type QueryDeliverableArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryDeliverableEnumerationsArgs = {
  input?: InputMaybe<DeliverableEnumerationInput>;
};


export type QueryDeliverablesArgs = {
  input?: InputMaybe<DeliverableInput>;
};


export type QueryEndUserSessionsArgs = {
  userID: Scalars['UUID']['input'];
};


export type QueryFilesArgs = {
  input?: InputMaybe<FileInput>;
};


export type QueryFinancesArgs = {
  input: FinanceInput;
};


export type QueryNewOrderNumberArgs = {
  input: Scalars['OrderType']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrderLinesArgs = {
  input?: InputMaybe<OrderLineInput>;
};


export type QueryOrdersArgs = {
  input?: InputMaybe<OrderInput>;
};


export type QueryPaymentArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryPaymentRedirectArgs = {
  input?: InputMaybe<PaymentRedirectInput>;
};


export type QueryPaymentsArgs = {
  input?: InputMaybe<PaymentInput>;
};


export type QueryRemovedCustomerArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemovedCustomersArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type QueryRemovedDeliverableArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemovedDeliverablesArgs = {
  input?: InputMaybe<DeliverableInput>;
};


export type QueryRemovedOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemovedOrdersArgs = {
  input?: InputMaybe<OrderInput>;
};


export type QueryRemovedSupplierArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemovedSuppliersArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type QueryRemovedTrademarkArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryRemovedTrademarksArgs = {
  input?: InputMaybe<TrademarkInput>;
};


export type QueryStartSessionArgs = {
  input: Credentials;
};


export type QuerySupplierArgs = {
  id: Scalars['UUID']['input'];
};


export type QuerySuppliersArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type QueryTrademarkArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryTrademarksArgs = {
  input?: InputMaybe<TrademarkInput>;
};


export type QueryUsersArgs = {
  input?: InputMaybe<UserInput>;
};

export type Supplier = {
  __typename?: 'Supplier';
  contactDetails?: Maybe<ContactDetailsResponse>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  orders?: Maybe<OrderResponse>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


export type SupplierContactDetailsArgs = {
  input?: InputMaybe<ContactDetailsInput>;
};


export type SupplierOrdersArgs = {
  input?: InputMaybe<OrderInput>;
};

export type SupplierContactDetailsFilter = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['Country']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['ContactDetailsType']['input']>>>;
};

export type SupplierCreate = {
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type SupplierFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type SupplierInput = {
  contactDetailsFilter?: InputMaybe<SupplierContactDetailsFilter>;
  order?: InputMaybe<Scalars['SupplierOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
  supplierFilter?: InputMaybe<SupplierFilter>;
};

export type SupplierResponse = {
  __typename?: 'SupplierResponse';
  records?: Maybe<Array<Maybe<Supplier>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type SupplierUpdate = {
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Trademark = {
  __typename?: 'Trademark';
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  deliverables?: Maybe<DeliverableResponse>;
  id?: Maybe<Scalars['UUID']['output']>;
  memorandum?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


export type TrademarkDeliverablesArgs = {
  input?: InputMaybe<DeliverableInput>;
};

export type TrademarkCreate = {
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type TrademarkFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type TrademarkInput = {
  order?: InputMaybe<Scalars['TrademarkOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
  trademarkFilter?: InputMaybe<TrademarkFilter>;
};

export type TrademarkResponse = {
  __typename?: 'TrademarkResponse';
  records?: Maybe<Array<Maybe<Trademark>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type TrademarkUpdate = {
  id: Scalars['UUID']['input'];
  memorandum?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UnitPrice = {
  __typename?: 'UnitPrice';
  /** Price including VAT. */
  gross?: Maybe<Scalars['Decimal']['output']>;
  /** Price excluding VAT. */
  net?: Maybe<Scalars['Decimal']['output']>;
};

export type User = {
  __typename?: 'User';
  contactDetails?: Maybe<ContactDetailsResponse>;
  createdAt?: Maybe<Scalars['Time']['output']>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  files?: Maybe<FileResponse>;
  id?: Maybe<Scalars['UUID']['output']>;
  loginID?: Maybe<Scalars['String']['output']>;
  loginSecret?: Maybe<Scalars['Secret']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['UserRole']['output']>>>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};


export type UserContactDetailsArgs = {
  input?: InputMaybe<ContactDetailsInput>;
};


export type UserFilesArgs = {
  input?: InputMaybe<FileInput>;
};

export type UserContactDetailsFilter = {
  countries?: InputMaybe<Array<InputMaybe<Scalars['Country']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['ContactDetailsType']['input']>>>;
};

export type UserCreate = {
  loginID: Scalars['String']['input'];
  loginSecret: Scalars['Secret']['input'];
  roles?: InputMaybe<Array<InputMaybe<Scalars['UserRole']['input']>>>;
};

export type UserFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  loginIDs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['UserRole']['input']>>>;
};

export type UserInput = {
  contactDetailsFilter?: InputMaybe<UserContactDetailsFilter>;
  order?: InputMaybe<Scalars['UserOrder']['input']>;
  plot?: InputMaybe<Plot>;
  search?: InputMaybe<Scalars['String']['input']>;
  userFilter?: InputMaybe<UserFilter>;
};

export type UserResponse = {
  __typename?: 'UserResponse';
  records?: Maybe<Array<Maybe<User>>>;
  recordsTotal?: Maybe<Scalars['Int']['output']>;
};

export type UserUpdate = {
  id: Scalars['UUID']['input'];
  loginID?: InputMaybe<Scalars['String']['input']>;
  loginSecret?: InputMaybe<Scalars['Secret']['input']>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['UserRole']['input']>>>;
};

export type Vat = {
  __typename?: 'VAT';
  /** Total cost amount of VAT for rate. */
  cost?: Maybe<Scalars['Decimal']['output']>;
  /** VAT rate. */
  rate?: Maybe<Scalars['Decimal']['output']>;
  /** Total revenue amount of VAT for rate. */
  revenue?: Maybe<Scalars['Decimal']['output']>;
};

export type Join__ContextArgument = {
  context: Scalars['String']['input'];
  name: Scalars['String']['input'];
  selection: Scalars['join__FieldValue']['input'];
  type: Scalars['String']['input'];
};

export enum Join__Graph {
  ContactDetails = 'CONTACT_DETAILS',
  Customer = 'CUSTOMER',
  Deliverable = 'DELIVERABLE',
  Enumeration = 'ENUMERATION',
  File = 'FILE',
  Finance = 'FINANCE',
  Order = 'ORDER',
  OrderLine = 'ORDER_LINE',
  Payment = 'PAYMENT',
  Price = 'PRICE',
  Session = 'SESSION',
  Supplier = 'SUPPLIER',
  Trademark = 'TRADEMARK',
  User = 'USER'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type CreateContactDetailsMutationVariables = Exact<{
  input: ContactDetailsCreate;
}>;


export type CreateContactDetailsMutation = { __typename?: 'Mutation', createContactDetails?: { __typename?: 'ContactDetails', id?: any | null } | null };

export type UpdateContactDetailsMutationVariables = Exact<{
  input: ContactDetailsUpdate;
}>;


export type UpdateContactDetailsMutation = { __typename?: 'Mutation', updateContactDetails?: { __typename?: 'ContactDetails', id?: any | null } | null };

export type RemoveContactDetailsMutationVariables = Exact<{
  contactDetailsID: Scalars['UUID']['input'];
}>;


export type RemoveContactDetailsMutation = { __typename?: 'Mutation', removeContactDetails?: { __typename?: 'ContactDetails', id?: any | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerCreate;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'Customer', id?: any | null } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: CustomerUpdate;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename?: 'Customer', id?: any | null } | null };

export type RemoveCustomerMutationVariables = Exact<{
  customerID: Scalars['UUID']['input'];
}>;


export type RemoveCustomerMutation = { __typename?: 'Mutation', removeCustomer?: { __typename?: 'Customer', id?: any | null } | null };

export type CreateDeliverableMutationVariables = Exact<{
  input: DeliverableCreate;
}>;


export type CreateDeliverableMutation = { __typename?: 'Mutation', createDeliverable?: { __typename?: 'Deliverable', id?: any | null } | null };

export type UpdateDeliverableMutationVariables = Exact<{
  input: DeliverableUpdate;
}>;


export type UpdateDeliverableMutation = { __typename?: 'Mutation', updateDeliverable?: { __typename?: 'Deliverable', id?: any | null } | null };

export type RemoveDeliverableMutationVariables = Exact<{
  deliverableID: Scalars['UUID']['input'];
}>;


export type RemoveDeliverableMutation = { __typename?: 'Mutation', removeDeliverable?: { __typename?: 'Deliverable', id?: any | null } | null };

export type CreateFileMutationVariables = Exact<{
  input: FileCreate;
}>;


export type CreateFileMutation = { __typename?: 'Mutation', createFile?: { __typename?: 'File', id?: any | null } | null };

export type UpdateFileMutationVariables = Exact<{
  input: FileUpdate;
}>;


export type UpdateFileMutation = { __typename?: 'Mutation', updateFile?: { __typename?: 'File', id?: any | null } | null };

export type RemoveFileMutationVariables = Exact<{
  fileID: Scalars['UUID']['input'];
}>;


export type RemoveFileMutation = { __typename?: 'Mutation', removeFile?: { __typename?: 'File', id?: any | null } | null };

export type CreateOrderMutationVariables = Exact<{
  input: OrderCreate;
}>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'Order', id?: any | null } | null };

export type UpdateOrderMutationVariables = Exact<{
  input: OrderUpdate;
}>;


export type UpdateOrderMutation = { __typename?: 'Mutation', updateOrder?: { __typename?: 'Order', id?: any | null } | null };

export type RemoveOrderMutationVariables = Exact<{
  orderID: Scalars['UUID']['input'];
}>;


export type RemoveOrderMutation = { __typename?: 'Mutation', removeOrder?: { __typename?: 'Order', id?: any | null } | null };

export type CreateOrderLineMutationVariables = Exact<{
  input: OrderLineCreate;
}>;


export type CreateOrderLineMutation = { __typename?: 'Mutation', createOrderLine?: { __typename?: 'OrderLine', id?: any | null } | null };

export type UpdateOrderLineMutationVariables = Exact<{
  input: OrderLineUpdate;
}>;


export type UpdateOrderLineMutation = { __typename?: 'Mutation', updateOrderLine?: { __typename?: 'OrderLine', id?: any | null } | null };

export type RemoveOrderLineMutationVariables = Exact<{
  orderLineID: Scalars['UUID']['input'];
}>;


export type RemoveOrderLineMutation = { __typename?: 'Mutation', removeOrderLine?: { __typename?: 'OrderLine', id?: any | null } | null };

export type CreateSupplierMutationVariables = Exact<{
  input: SupplierCreate;
}>;


export type CreateSupplierMutation = { __typename?: 'Mutation', createSupplier?: { __typename?: 'Supplier', id?: any | null } | null };

export type UpdateSupplierMutationVariables = Exact<{
  input: SupplierUpdate;
}>;


export type UpdateSupplierMutation = { __typename?: 'Mutation', updateSupplier?: { __typename?: 'Supplier', id?: any | null } | null };

export type RemoveSupplierMutationVariables = Exact<{
  supplierID: Scalars['UUID']['input'];
}>;


export type RemoveSupplierMutation = { __typename?: 'Mutation', removeSupplier?: { __typename?: 'Supplier', id?: any | null } | null };

export type CreateTrademarkMutationVariables = Exact<{
  input: TrademarkCreate;
}>;


export type CreateTrademarkMutation = { __typename?: 'Mutation', createTrademark?: { __typename?: 'Trademark', id?: any | null } | null };

export type UpdateTrademarkMutationVariables = Exact<{
  input: TrademarkUpdate;
}>;


export type UpdateTrademarkMutation = { __typename?: 'Mutation', updateTrademark?: { __typename?: 'Trademark', id?: any | null } | null };

export type RemoveTrademarkMutationVariables = Exact<{
  trademarkID: Scalars['UUID']['input'];
}>;


export type RemoveTrademarkMutation = { __typename?: 'Mutation', removeTrademark?: { __typename?: 'Trademark', id?: any | null } | null };

export type CustomerSelectorQueryVariables = Exact<{
  input?: InputMaybe<CustomerInput>;
}>;


export type CustomerSelectorQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomerResponse', recordsTotal?: number | null, records?: Array<{ __typename?: 'Customer', id?: any | null, name?: string | null, number?: number | null, type?: any | null, contactDetails?: { __typename?: 'ContactDetailsResponse', records?: Array<{ __typename?: 'ContactDetails', address?: string | null, city?: string | null, country?: any | null, email?: any | null, forename?: string | null, phone?: string | null, postalCode?: string | null, surname?: string | null, surnamePrefix?: string | null, type?: any | null } | null> | null } | null } | null> | null } | null };

export type CustomerSummaryQueryVariables = Exact<{
  customerID: Scalars['UUID']['input'];
}>;


export type CustomerSummaryQuery = { __typename?: 'Query', customers?: { __typename?: 'CustomerResponse', records?: Array<{ __typename?: 'Customer', id?: any | null, memorandum?: string | null, name?: string | null, number?: number | null, type?: any | null, contactDetails?: { __typename?: 'ContactDetailsResponse', records?: Array<{ __typename?: 'ContactDetails', address?: string | null, city?: string | null, country?: any | null, email?: any | null, forename?: string | null, id?: any | null, phone?: string | null, postalCode?: string | null, priority?: number | null, surname?: string | null, surnamePrefix?: string | null, type?: any | null, website?: any | null } | null> | null } | null, orders?: { __typename?: 'OrderResponse', records?: Array<{ __typename?: 'Order', billedAt?: any | null, currency?: any | null, discountType?: any | null, discountValue?: any | null, memorandum?: string | null, number?: number | null, reference?: string | null, shiftedVAT?: boolean | null, status?: any | null, type?: any | null } | null> | null } | null } | null> | null } | null };

export type NewCustomerNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type NewCustomerNumberQuery = { __typename?: 'Query', newCustomerNumber?: number | null };

export type DeliverableSummaryQueryVariables = Exact<{
  deliverableID: Scalars['UUID']['input'];
}>;


export type DeliverableSummaryQuery = { __typename?: 'Query', deliverable?: { __typename?: 'Deliverable', currency?: any | null, description?: string | null, id?: any | null, ean?: string | null, memorandum?: string | null, name?: string | null, type?: any | null, unit?: string | null, vatRate?: any | null, trademark?: { __typename?: 'Trademark', name?: string | null } | null, unitPrice?: { __typename?: 'UnitPrice', gross?: any | null, net?: any | null } | null } | null };

export type DeliverableSelectorQueryVariables = Exact<{
  input?: InputMaybe<DeliverableInput>;
}>;


export type DeliverableSelectorQuery = { __typename?: 'Query', deliverables?: { __typename?: 'DeliverableResponse', recordsTotal?: number | null, records?: Array<{ __typename?: 'Deliverable', currency?: any | null, id?: any | null, name?: string | null, type?: any | null, unit?: string | null, vatRate?: any | null, trademark?: { __typename?: 'Trademark', name?: string | null } | null, unitPrice?: { __typename?: 'UnitPrice', gross?: any | null, net?: any | null } | null } | null> | null } | null };

export type ContactDetailsEnumerationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactDetailsEnumerationsQuery = { __typename?: 'Query', contactDetailsEnumerations?: { __typename?: 'ContactDetailsEnumerationResponse', orders?: Array<any | null> | null, types?: Array<any | null> | null } | null };

export type CustomerEnumerationsQueryVariables = Exact<{
  input?: InputMaybe<CustomerEnumerationInput>;
}>;


export type CustomerEnumerationsQuery = { __typename?: 'Query', customerEnumerations?: { __typename?: 'CustomerEnumerationResponse', orders?: Array<any | null> | null, types?: Array<any | null> | null } | null };

export type DeliverableEnumerationsQueryVariables = Exact<{
  input?: InputMaybe<DeliverableEnumerationInput>;
}>;


export type DeliverableEnumerationsQuery = { __typename?: 'Query', deliverableEnumerations?: { __typename?: 'DeliverableEnumerationResponse', orders?: Array<any | null> | null, types?: Array<any | null> | null } | null };

export type OrderEnumerationsQueryVariables = Exact<{ [key: string]: never; }>;


export type OrderEnumerationsQuery = { __typename?: 'Query', orderEnumerations?: { __typename?: 'OrderEnumerationResponse', orders?: Array<any | null> | null, statuses?: Array<any | null> | null, types?: Array<any | null> | null } | null };

export type FinanceOverviewQueryVariables = Exact<{
  input: FinanceInput;
}>;


export type FinanceOverviewQuery = { __typename?: 'Query', finances?: { __typename?: 'FinanceResponse', costGross?: any | null, costNet?: any | null, profitGross?: any | null, profitNet?: any | null, revenueGross?: any | null, revenueNet?: any | null, vat?: Array<{ __typename?: 'VAT', cost?: any | null, rate?: any | null, revenue?: any | null } | null> | null } | null };

export type OrderSummaryQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OrderSummaryQuery = { __typename?: 'Query', order?: { __typename?: 'Order', currency?: any | null, id?: any | null, memorandum?: string | null, paid?: any | null, received?: any | null, relationType?: any | null, type?: any | null, customer?: { __typename?: 'Customer', name?: string | null, number?: number | null, type?: any | null } | null, files?: { __typename?: 'FileResponse', records?: Array<{ __typename?: 'File', description?: string | null, extension?: string | null, id?: any | null, name?: string | null, priority?: number | null, type?: any | null, url?: any | null } | null> | null } | null, orderLines?: { __typename?: 'OrderLineResponse', records?: Array<{ __typename?: 'OrderLine', amount?: any | null, description?: string | null, discountType?: any | null, discountValue?: any | null, unit?: string | null, vatRate?: any | null, price?: { __typename?: 'OrderPrice', grossTotal?: any | null } | null, unitPrice?: { __typename?: 'UnitPrice', gross?: any | null, net?: any | null } | null } | null> | null } | null, price?: { __typename?: 'OrderPrice', grossTotal?: any | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null };

export type OrderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order?: { __typename?: 'Order', billedAt?: any | null, currency?: any | null, discountType?: any | null, discountValue?: any | null, id?: any | null, memorandum?: string | null, number?: number | null, reference?: string | null, relationID?: any | null, relationType?: any | null, shiftedVAT?: boolean | null, status?: any | null, type?: any | null, contactDetails?: { __typename?: 'ContactDetailsResponse', records?: Array<{ __typename?: 'ContactDetails', address?: string | null, city?: string | null, country?: any | null, email?: any | null, forename?: string | null, id?: any | null, phone?: string | null, postalCode?: string | null, priority?: number | null, surname?: string | null, surnamePrefix?: string | null, type?: any | null, website?: any | null } | null> | null } | null, customer?: { __typename?: 'Customer', id?: any | null, name?: string | null, number?: number | null, type?: any | null } | null, files?: { __typename?: 'FileResponse', records?: Array<{ __typename?: 'File', description?: string | null, extension?: string | null, id?: any | null, name?: string | null, priority?: number | null, type?: any | null, url?: any | null } | null> | null } | null, orderLines?: { __typename?: 'OrderLineResponse', records?: Array<{ __typename?: 'OrderLine', amount?: any | null, description?: string | null, discountType?: any | null, discountValue?: any | null, id?: any | null, priority?: number | null, unit?: string | null, vatRate?: any | null, price?: { __typename?: 'OrderPrice', grossTotal?: any | null } | null, unitPrice?: { __typename?: 'UnitPrice', gross?: any | null, net?: any | null } | null } | null> | null } | null, supplier?: { __typename?: 'Supplier', id?: any | null, name?: string | null } | null } | null };

export type NewOrderNumberQueryVariables = Exact<{
  input: Scalars['OrderType']['input'];
}>;


export type NewOrderNumberQuery = { __typename?: 'Query', newOrderNumber?: number | null };

export type OrderSelectorQueryVariables = Exact<{
  input?: InputMaybe<OrderInput>;
}>;


export type OrderSelectorQuery = { __typename?: 'Query', orders?: { __typename?: 'OrderResponse', recordsTotal?: number | null, records?: Array<{ __typename?: 'Order', billedAt?: any | null, id?: any | null, number?: number | null, reference?: string | null, status?: any | null, type?: any | null, customer?: { __typename?: 'Customer', name?: string | null } | null, supplier?: { __typename?: 'Supplier', name?: string | null } | null } | null> | null } | null };

export type PaymentRedirectQueryVariables = Exact<{
  input: PaymentRedirectInput;
}>;


export type PaymentRedirectQuery = { __typename?: 'Query', paymentRedirect?: any | null };

export type StartSessionQueryVariables = Exact<{
  id: Scalars['String']['input'];
  secret: Scalars['String']['input'];
}>;


export type StartSessionQuery = { __typename?: 'Query', startSession?: string | null };

export type SessionRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type SessionRolesQuery = { __typename?: 'Query', sessionRoles?: Array<any | null> | null };

export type SupplierSelectorQueryVariables = Exact<{
  input?: InputMaybe<SupplierInput>;
}>;


export type SupplierSelectorQuery = { __typename?: 'Query', suppliers?: { __typename?: 'SupplierResponse', recordsTotal?: number | null, records?: Array<{ __typename?: 'Supplier', id?: any | null, name?: string | null, contactDetails?: { __typename?: 'ContactDetailsResponse', records?: Array<{ __typename?: 'ContactDetails', address?: string | null, city?: string | null, country?: any | null, email?: any | null, forename?: string | null, phone?: string | null, postalCode?: string | null, surname?: string | null, surnamePrefix?: string | null, type?: any | null } | null> | null } | null } | null> | null } | null };

export type SupplierSummaryQueryVariables = Exact<{
  supplierID: Scalars['UUID']['input'];
}>;


export type SupplierSummaryQuery = { __typename?: 'Query', supplier?: { __typename?: 'Supplier', id?: any | null, memorandum?: string | null, name?: string | null, contactDetails?: { __typename?: 'ContactDetailsResponse', records?: Array<{ __typename?: 'ContactDetails', address?: string | null, city?: string | null, country?: any | null, email?: any | null, forename?: string | null, id?: any | null, phone?: string | null, postalCode?: string | null, priority?: number | null, surname?: string | null, surnamePrefix?: string | null, type?: any | null, website?: any | null } | null> | null } | null, orders?: { __typename?: 'OrderResponse', records?: Array<{ __typename?: 'Order', billedAt?: any | null, currency?: any | null, discountType?: any | null, discountValue?: any | null, memorandum?: string | null, number?: number | null, reference?: string | null, shiftedVAT?: boolean | null, status?: any | null, type?: any | null } | null> | null } | null } | null };

export type TrademarkSummaryQueryVariables = Exact<{
  trademarkID: Scalars['UUID']['input'];
}>;


export type TrademarkSummaryQuery = { __typename?: 'Query', trademark?: { __typename?: 'Trademark', id?: any | null, memorandum?: string | null, name?: string | null } | null };

export type TrademarkSelectorQueryVariables = Exact<{
  input?: InputMaybe<TrademarkInput>;
}>;


export type TrademarkSelectorQuery = { __typename?: 'Query', trademarks?: { __typename?: 'TrademarkResponse', recordsTotal?: number | null, records?: Array<{ __typename?: 'Trademark', id?: any | null, memorandum?: string | null, name?: string | null } | null> | null } | null };


export const CreateContactDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateContactDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactDetailsCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createContactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateContactDetailsMutation, CreateContactDetailsMutationVariables>;
export const UpdateContactDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateContactDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContactDetailsUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateContactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateContactDetailsMutation, UpdateContactDetailsMutationVariables>;
export const RemoveContactDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveContactDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"contactDetailsID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeContactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"contactDetailsID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveContactDetailsMutation, RemoveContactDetailsMutationVariables>;
export const CreateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerMutation, CreateCustomerMutationVariables>;
export const UpdateCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateCustomerMutation, UpdateCustomerMutationVariables>;
export const RemoveCustomerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveCustomer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeCustomer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveCustomerMutation, RemoveCustomerMutationVariables>;
export const CreateDeliverableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateDeliverable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliverableCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createDeliverable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateDeliverableMutation, CreateDeliverableMutationVariables>;
export const UpdateDeliverableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateDeliverable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliverableUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateDeliverable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateDeliverableMutation, UpdateDeliverableMutationVariables>;
export const RemoveDeliverableDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveDeliverable"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliverableID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeDeliverable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliverableID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveDeliverableMutation, RemoveDeliverableMutationVariables>;
export const CreateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateFileMutation, CreateFileMutationVariables>;
export const UpdateFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateFileMutation, UpdateFileMutationVariables>;
export const RemoveFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveFileMutation, RemoveFileMutationVariables>;
export const CreateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOrderMutation, CreateOrderMutationVariables>;
export const UpdateOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderMutation, UpdateOrderMutationVariables>;
export const RemoveOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveOrderMutation, RemoveOrderMutationVariables>;
export const CreateOrderLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOrderLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOrderLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateOrderLineMutation, CreateOrderLineMutationVariables>;
export const UpdateOrderLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrderLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderLineUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOrderLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateOrderLineMutation, UpdateOrderLineMutationVariables>;
export const RemoveOrderLineDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveOrderLine"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderLineID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeOrderLine"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderLineID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveOrderLineMutation, RemoveOrderLineMutationVariables>;
export const CreateSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateSupplierMutation, CreateSupplierMutationVariables>;
export const UpdateSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateSupplierMutation, UpdateSupplierMutationVariables>;
export const RemoveSupplierDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSupplier"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSupplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveSupplierMutation, RemoveSupplierMutationVariables>;
export const CreateTrademarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTrademark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrademarkCreate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTrademark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateTrademarkMutation, CreateTrademarkMutationVariables>;
export const UpdateTrademarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTrademark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TrademarkUpdate"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTrademark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateTrademarkMutation, UpdateTrademarkMutationVariables>;
export const RemoveTrademarkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTrademark"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trademarkID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTrademark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trademarkID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RemoveTrademarkMutation, RemoveTrademarkMutationVariables>;
export const CustomerSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"forename"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"surnamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordsTotal"}}]}}]}}]} as unknown as DocumentNode<CustomerSelectorQuery, CustomerSelectorQueryVariables>;
export const CustomerSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customerID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"customerFilter"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"ids"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"customerID"}}]}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"forename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"surnamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"NUMBER_DESCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billedAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"shiftedVAT"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]} as unknown as DocumentNode<CustomerSummaryQuery, CustomerSummaryQueryVariables>;
export const NewCustomerNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewCustomerNumber"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newCustomerNumber"}}]}}]} as unknown as DocumentNode<NewCustomerNumberQuery, NewCustomerNumberQueryVariables>;
export const DeliverableSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliverableSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deliverableID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliverable"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deliverableID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ean"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trademark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}}]}}]} as unknown as DocumentNode<DeliverableSummaryQuery, DeliverableSummaryQueryVariables>;
export const DeliverableSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliverableSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliverableInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliverables"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trademark"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordsTotal"}}]}}]}}]} as unknown as DocumentNode<DeliverableSelectorQuery, DeliverableSelectorQueryVariables>;
export const ContactDetailsEnumerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ContactDetailsEnumerations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactDetailsEnumerations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<ContactDetailsEnumerationsQuery, ContactDetailsEnumerationsQueryVariables>;
export const CustomerEnumerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomerEnumerations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomerEnumerationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerEnumerations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<CustomerEnumerationsQuery, CustomerEnumerationsQueryVariables>;
export const DeliverableEnumerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DeliverableEnumerations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DeliverableEnumerationInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deliverableEnumerations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<DeliverableEnumerationsQuery, DeliverableEnumerationsQueryVariables>;
export const OrderEnumerationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderEnumerations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orderEnumerations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"}},{"kind":"Field","name":{"kind":"Name","value":"statuses"}},{"kind":"Field","name":{"kind":"Name","value":"types"}}]}}]}}]} as unknown as DocumentNode<OrderEnumerationsQuery, OrderEnumerationsQueryVariables>;
export const FinanceOverviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FinanceOverview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FinanceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"finances"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"costGross"}},{"kind":"Field","name":{"kind":"Name","value":"costNet"}},{"kind":"Field","name":{"kind":"Name","value":"profitGross"}},{"kind":"Field","name":{"kind":"Name","value":"profitNet"}},{"kind":"Field","name":{"kind":"Name","value":"revenueGross"}},{"kind":"Field","name":{"kind":"Name","value":"revenueNet"}},{"kind":"Field","name":{"kind":"Name","value":"vat"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"rate"}},{"kind":"Field","name":{"kind":"Name","value":"revenue"}}]}}]}}]}}]} as unknown as DocumentNode<FinanceOverviewQuery, FinanceOverviewQueryVariables>;
export const OrderSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"orderLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grossTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"paid"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grossTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"received"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<OrderSummaryQuery, OrderSummaryQueryVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billedAt"}},{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"forename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"surnamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"extension"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"orderLines"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"grossTotal"}}]}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"unitPrice"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gross"}},{"kind":"Field","name":{"kind":"Name","value":"net"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vatRate"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"relationID"}},{"kind":"Field","name":{"kind":"Name","value":"relationType"}},{"kind":"Field","name":{"kind":"Name","value":"shiftedVAT"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const NewOrderNumberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NewOrderNumber"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newOrderNumber"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<NewOrderNumberQuery, NewOrderNumberQueryVariables>;
export const OrderSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrderSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billedAt"}},{"kind":"Field","name":{"kind":"Name","value":"customer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supplier"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordsTotal"}}]}}]}}]} as unknown as DocumentNode<OrderSelectorQuery, OrderSelectorQueryVariables>;
export const PaymentRedirectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PaymentRedirect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentRedirectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentRedirect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<PaymentRedirectQuery, PaymentRedirectQueryVariables>;
export const StartSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StartSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"secret"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"secret"},"value":{"kind":"Variable","name":{"kind":"Name","value":"secret"}}}]}}]}]}}]} as unknown as DocumentNode<StartSessionQuery, StartSessionQueryVariables>;
export const SessionRolesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SessionRoles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sessionRoles"}}]}}]} as unknown as DocumentNode<SessionRolesQuery, SessionRolesQueryVariables>;
export const SupplierSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"SupplierInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"suppliers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"forename"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"surnamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordsTotal"}}]}}]}}]} as unknown as DocumentNode<SupplierSelectorQuery, SupplierSelectorQueryVariables>;
export const SupplierSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SupplierSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"supplierID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"supplier"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"supplierID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"PRIORITY_ASCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"forename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"postalCode"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"surnamePrefix"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"website"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"order"},"value":{"kind":"StringValue","value":"BILLED_AT_DESCENDING","block":false}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billedAt"}},{"kind":"Field","name":{"kind":"Name","value":"currency"}},{"kind":"Field","name":{"kind":"Name","value":"discountType"}},{"kind":"Field","name":{"kind":"Name","value":"discountValue"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"reference"}},{"kind":"Field","name":{"kind":"Name","value":"shiftedVAT"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SupplierSummaryQuery, SupplierSummaryQueryVariables>;
export const TrademarkSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrademarkSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trademarkID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trademark"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trademarkID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<TrademarkSummaryQuery, TrademarkSummaryQueryVariables>;
export const TrademarkSelectorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TrademarkSelector"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrademarkInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trademarks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"records"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"memorandum"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recordsTotal"}}]}}]}}]} as unknown as DocumentNode<TrademarkSelectorQuery, TrademarkSelectorQueryVariables>;